module.exports = __webpack_public_path__ + "img/icon_more.449bd903.svg";